import { render } from "./AppCaseViewPopUp.vue?vue&type=template&id=f3715938&scoped=true&ts=true"
import script from "./AppCaseViewPopUp.vue?vue&type=script&lang=ts"
export * from "./AppCaseViewPopUp.vue?vue&type=script&lang=ts"

import "./AppCaseViewPopUp.vue?vue&type=style&index=0&id=f3715938&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3715938"]])

export default __exports__